<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        class="white m-2 caption text-capitalize"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon size="18" class="mr-2"> mdi-translate </v-icon>
        <!-- {{ $t("header.select_lang") }} -->
        <b> ({{ selected }}) </b>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        style="min-height: 35px"
        v-for="(item, index) in languages"
        :key="index"
      >
        <v-list-item-title
          class="caption text-capitalize"
          style="cursor: pointer"
          @click="changeLocale(item.short)"
          >{{ item.title }}</v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import Vue from "vue";
export default {
  name: "SelectLanguage",
  data() {
    return {
      languages: this.getLangs(),
      selected: this.$i18n.locale,
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (val, oldVal) {
        this.languages = this.getLangs();
      },
      deep: true,
    },
  },
  created() {
    const storageLocale = this.$store.state.locale;
    if (storageLocale) {
      this.selected = storageLocale;
      this.$i18n.locale = storageLocale;
    }
  },
  methods: {
    getLangs() {
      return [
        { title: this.$t("turkish"), short: "tr" },
        { title: this.$t("english"), short: "en" },
      ];
    },
    //
    changeLocale(value) {
      this.$i18n.locale = value;
      this.selected = value;
      this.$store.commit("setLocale", value);

      window.localStorage.setItem("locale", value);
    },
  },
};
</script>
<style lang="scss"></style>
